<template>
  <PopularProfessionsSection :content="content" />
</template>

<script>
import { onMounted, useContext } from "@nuxtjs/composition-api";
import PopularProfessionsSection from "~/components/_refactored/indexPage/PopularProfessionsSection.vue";
import useModuleContent from "~/composables/useModuleContent";

export default {
  name: "PopularProfessionsModule",
  components: {
    PopularProfessionsSection,
  },
  props: {
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { $posthog } = useContext();
    const { content } = useModuleContent(props);

    onMounted(() => {
      $posthog?.capture("front_page_module_viewed", {
        module_slug: props.moduleConfig.slug,
        module_position: props.moduleConfig.position,
        module_row: props.moduleConfig.row,
        version_id: props.moduleConfig.versionId,
      });
    });

    return { content };
  },
};
</script>
